const openPanelInNewTab = ()=>{
    window.open(process.env.REACT_APP_PANEL_URL, "_blank", "noopener,noreferrer");
    window.location.reload();
}

export default openPanelInNewTab;